import { RouteObject } from "react-router";
import AppExtensionProviderRegistry, { AppExtension, AppExtensionProvider } from "../../framework/app/app.extension.provider";
import MMAdminWelcomePage from "./welcome/mmadmin.welcome.page";
import { DashboardComponent } from "react-admin";
import MMAdminMenu from "./mmadmin.custom.menu";


export const PRODUCT = "mmadmin";

export class MMAdminAppExtensionProvider implements AppExtensionProvider {
    
    constructor() { 
      AppExtensionProviderRegistry.registerProvider(
        PRODUCT,
        this
      );
    }
    
    getAppExtension(): AppExtension {
      return {
        getAppImage: () => {
            return `./products/${PRODUCT}/banner.png`
        },
        getAppBar: () => {
          return null;
        },
        getMenu: () => {
          return MMAdminMenu;
        },
        getRoutes: ():RouteObject[] => {
          const welcome:RouteObject = {
            path: "/welcomeToMMAdmin",
            element: MMAdminWelcomePage
        }
        return [welcome];
        },
        getDefaultRoute: () => {
            return `/welcomeToMMAdmin`;
        },
        getWelcomePage():DashboardComponent {
            return MMAdminWelcomePage;
        },
      };
    }
  }